import React, { useRef, useEffect } from "react";
import {
  I2cInput,
  I2cRadio,
  I2cRadioButton,
  I2cRadioGroup,
  I2cCheckboxGroup,
  I2cListItem,
  I2cCheckbox,
  I2cIcon,
  I2cTooltip,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../Prepaid.scss";

import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { features, otpDeliveryMethods, yellowPathOtp, liveAgent, emailAgent } from "./stringUtils";
import { validationSchemaDigitalWallet } from "./validationScheme";
const DigitalWallet = ({
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => { 

  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchemaDigitalWallet),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "all",
    defaultValues: {
      of_dw_mobile_wallets: [],
      of_dw_mobile_wallet_other: "",
      of_dw_card_holders: [],
      of_dw_live_agent: "",
      of_dw_live_agent_other: "",
      of_dw_email_authentication: "",
      of_dw_email_authentication_other: "",
      of_dw_otp_delivery: [],
      of_dw_provisioning_process: "yes",
      of_dw_i2c_mobile_app_host: "yes",
      of_dw_service_enable_via: "",
    },
  });

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  const fields = [
    "of_dw_mobile_wallets",
    "of_dw_mobile_wallet_other",
    "of_dw_card_holders",
    "of_dw_live_agent",
    "of_dw_live_agent_other",
    "of_dw_email_authentication",
    "of_dw_email_authentication_other",
    "of_dw_otp_delivery",
    "of_dw_provisioning_process",
    "of_dw_i2c_mobile_app_host",
    "of_dw_service_enable_via",
  ];
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        methods.setValue(field, formDataJson[2]["2_2"][field] ?? "");
      });
      methods.trigger();
    }
  }, [isFetching]);

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      2: {
        ...addFormData["2"],
        "2_2": { ...values },
      },
    });
  };

  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("2_2", true);
    else setFormValidStates("2_2", false);
  }, [Object.keys(errors).length]);
  const checkboxRef = useRef(null);
  const inAppProvision = ["Yes", "No","N/A"];
  const enableServiceViaOptions = ["SDK", "API","N/A"];
  const handleCheckboxGroupChangeReal = (event) => {
    let selectedValues;
    if (!event.length) selectedValues = event.target.value;
    else selectedValues = event;
    let updatedValues = [...(methods.getValues("of_dw_mobile_wallets") ?? [])];
    if (updatedValues.includes(selectedValues)) {
      // If the card is already selected, remove it
      updatedValues = updatedValues.filter((card) => card !== selectedValues);
    } else {
      // If the card is not selected, add it
      updatedValues.push(selectedValues);
    }

    if (updatedValues.includes("apple-pay")) {
      const vals = yellowPathOtp.map((obj) => obj.value);
      methods.setValue("of_dw_card_holders", vals);
    }
    if (!updatedValues.includes("others")) {
      methods.setValue("of_dw_mobile_wallet_other", "");
    }
    methods.setValue("of_dw_mobile_wallets", updatedValues);
    methods.trigger();
    handleValueChanges();
  };
  const handleCheckboxGroupChange = (event) => {
    let selectedValues;
    if (!event.length) selectedValues = event.target.value;
    else selectedValues = event;
  
    let updatedValues = [...(methods.getValues("of_dw_mobile_wallets") ?? [])];
    if (updatedValues.includes(selectedValues)) {
      // If the value is already selected, remove it
      updatedValues = updatedValues.filter((card) => card !== selectedValues);
    } else {
      // If the value is not selected, add it
      updatedValues.push(selectedValues);
    }
  
    // Handle Apple Pay specific logic
    if (selectedValues === "apple-pay") {
      if (updatedValues.includes("apple-pay")) {
        // When Apple Pay is selected, set all yellowPathOtp values
        const vals = yellowPathOtp.map((obj) => obj.value);
        methods.setValue("of_dw_card_holders", vals);
      } else {
        // When Apple Pay is deselected, clear of_dw_card_holders
        methods.setValue("of_dw_card_holders", []);
        // Also clear dependent fields
        methods.setValue("of_dw_live_agent", "");
        methods.setValue("of_dw_live_agent_other", "");
        methods.setValue("of_dw_email_authentication", "");
        methods.setValue("of_dw_email_authentication_other", "");
      }
    }
  
    // Clear other field if "others" is not selected
    if (!updatedValues.includes("others")) {
      methods.setValue("of_dw_mobile_wallet_other", "");
    }
  
    methods.setValue("of_dw_mobile_wallets", updatedValues);
    methods.trigger();
    handleValueChanges();
  };
  const handleYellowPathChange = (event) => {
    let selectedValues;
    if (!event.length) selectedValues = event.target.value;
    else selectedValues = event;
    let updatedValues = [...(methods.getValues("of_dw_card_holders") ?? [])];
    if (updatedValues.includes(selectedValues)) {
      // If the card is already selected, remove it
      updatedValues = updatedValues.filter((card) => card !== selectedValues);
    } else {
      // If the card is not selected, add it
      updatedValues.push(selectedValues);
    }
    if (!updatedValues.includes("live-agent")) {
      methods.setValue("of_dw_live_agent", "");
      methods.setValue("of_dw_live_agent_other", "");
    }
    if (!updatedValues.includes("via-email")) {
      methods.setValue("of_dw_email_authentication", "");
      methods.setValue("of_dw_email_authentication_other", "");
    }
    methods.setValue("of_dw_card_holders", updatedValues);
    methods.trigger();
    handleValueChanges();
  };
  const handleOTPDeliveryMethodsChange = (event) => {
    let selectedValues;
    if (!event?.length) selectedValues = event.target.value;
    else selectedValues = event;
    let updatedValues = [...(methods.getValues("of_dw_otp_delivery") ?? [])];
    if (updatedValues.includes(selectedValues)) {
      // If the card is already selected, remove it
      updatedValues = updatedValues.filter((card) => card !== selectedValues);
    } else {
      // If the card is not selected, add it
      updatedValues.push(selectedValues);
    }
    methods.setValue("of_dw_otp_delivery", updatedValues);
    handleValueChanges();
    methods.trigger();
  };
  return (
    <React.Fragment>
      <div className="forms-instance">
        <div className="section-space">
          <span slot="label" className="organize-tooltip mb-16">
            <div className="sub-heading">Mobile Wallets</div>
            <I2cTooltip
              content="As a pre-requisite to initiate mobile wallet setup, the sponsor bank must have a have a contract with the mobile wallet service provider and the BIN should already be live on the card network."
              placement="right-start"
            >
              <I2cIcon label="placement" name="cs-linear-info" color="#6B7080"></I2cIcon>
            </I2cTooltip>
          </span>
          <I2cCheckboxGroup className="centeredCheckbox" ref={checkboxRef}>
            <div i2c-grid="grid gap-sm">
              {features.map((card, index) => (
                <I2cListItem
                  key={index}
                  i2c-grid="4@md 2@xl"
                  style={{ display: "flex", alignItems: "center" }}
                  variant="receipt"
                  label={card.label}
                  sublabel=""
                  value=""
                  type="checkbox"
                  checked={
                    methods
                      .watch("of_dw_mobile_wallets")
                      ?.includes(card.value) ?? false
                  }
                  onI2cCheckboxClicked={(e) => {
                    handleCheckboxGroupChange(card.value);
                    methods.trigger();
                    handleValueChanges();
                  }}
                  size="sm"
                >
                  <I2cIcon
                    slot="prefix"
                    src={card.icon}
                    style={{ fontSize: "var(--i2c-spacing-10-5)" }}
                    label="icon"
                  ></I2cIcon>
                  <I2cCheckbox
                    name="ofdw_features"
                    slot="checkbox"
                    value={card.value}
                    label=""
                    filled
                    checked={
                      methods
                        .watch("of_dw_mobile_wallets")
                        ?.includes(card.value) ?? false
                    }
                
                    className="custom-checkbox-auto-margin"
                  ></I2cCheckbox>
                </I2cListItem>
              ))}
            </div>
          </I2cCheckboxGroup>
          <div i2c-grid="grid">
            {methods.watch("of_dw_mobile_wallets").includes("others") && (
              <div i2c-grid="4@md" className="mt-16">
                <div className="single-field-wrapper">
                  <Controller
                    name="of_dw_mobile_wallet_other"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        name={"of_dw_mobile_wallet_other"}
                        className="single-input-field"
                        placeholder="Other Details"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          methods.trigger();
                          handleValueChanges();
                        }} 
                        size="large"
                        label="Enter Details"
                      />
                    )}
                  />
                  {/* <ErrorMessage
                    show={
                      errors.of_dw_mobile_wallet_other &&
                      methods.formState.touchedFields.of_dw_mobile_wallet_other
                        ? true
                        : false
                    }
                    message={
                      errors.of_dw_mobile_wallet_other?.message ??
                      "Invalid input"
                    }
                  /> */}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="section-space">
          <div i2c-grid="grid gap-md">
            <div i2c-grid="12">
              <div className="sub-heading mb-4">
                Authentication for Yellow Path cardholders
              </div>
              <div className="custom-label-light mb-16">
                For Yellow Path (cardholders failing enrollment), please confirm
                what alternate methods for Cardholder Authentication will be
                used:
              </div>
              <I2cCheckboxGroup ref={checkboxRef}>
                <div i2c-grid="grid gap-sm">
                  {yellowPathOtp.map((yellowPathOtp, index) => (
                    <I2cListItem
                      key={index}
                      i2c-grid="4@md"
                      variant="receipt"
                      label={yellowPathOtp.label}
                      sublabel=""
                      value=""
                      disabled={methods
                        .watch("of_dw_mobile_wallets")
                        .includes("apple-pay")}
                      checked={
                        methods
                          .watch("of_dw_card_holders")
                          ?.includes(yellowPathOtp.value) ?? false
                      }
                  
                      onI2cCheckboxClicked={
                        methods.watch("of_dw_mobile_wallets").includes("apple-pay")
                          ? () => null
                          : (e) => handleYellowPathChange(yellowPathOtp.value)
                      }
                      className={
                        methods
                          .watch("of_dw_mobile_wallets")
                          .includes("apple-pay")
                          ? "disable-events"
                          : ""
                      }
                      type="checkbox"
                    >
                      <I2cCheckbox
                        slot="prefix"
                        name="ofdw_otpDelivery"
                        value={yellowPathOtp.value}
                        label=""
                        filled
                        checked={
                          methods
                            .watch("of_dw_card_holders")
                            ?.includes(yellowPathOtp.value) ?? false
                        }
                        className="customCheckbox"
                      ></I2cCheckbox>
                    </I2cListItem>
                  ))}
                </div>
              </I2cCheckboxGroup>
            </div>
            {methods.watch("of_dw_card_holders").includes("live-agent") && (
              <div i2c-grid="12">
                <I2cRadioGroup
                  label="If opting for “Live Agent”, please confirm who will provide the
                  contact center service for Live Agent support for cardholders:"
                  onI2cChange={(e) => {
                    methods.setValue("of_dw_live_agent", e.target.value);
                    if (e.target.value !== "other") {
                      methods.setValue("of_dw_live_agent_other", "");
                    }
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  <div i2c-grid="grid gap-sm">
                    {liveAgent.map((radio, index) => (
                      <I2cListItem
                        key={index}
                        i2c-grid="4@md"
                        variant="receipt"
                        label={radio.label}
                        sublabel=" "
                        value=""
                        checked={
                          methods.watch("of_dw_live_agent") === radio.value ??
                          false
                        }
                        type="checkbox"
                      >
                        <I2cRadio
                          filled
                          checked={
                            methods.watch("of_dw_live_agent") === radio.value ??
                            false
                          }
                          slot="prefix"
                          name="ofdw_liveAgent"
                          value={radio.value}
                        ></I2cRadio>
                      </I2cListItem>
                    ))}
                  </div>
                </I2cRadioGroup>
                {methods.watch("of_dw_live_agent") === "other" && (
                  <div i2c-grid="grid 4@md" className="mt-16">
                    <div className="single-field-wrapper">
                      <Controller
                        name="of_dw_live_agent_other"
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            name={"of_dw_live_agent_other"}
                            className="single-input-field"
                            placeholder="Please Specify"
                            onI2cInput={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              methods.trigger();
                              handleValueChanges();
                            }} 
                            size="large"
                            label="Enter Details"
                          />
                        )}
                      />
                      {/* <ErrorMessage
                        show={
                          errors.of_dw_live_agent_other &&
                          methods.formState.touchedFields.of_dw_live_agent_other
                            ? true
                            : false
                        }
                        message={
                          errors.of_dw_live_agent_other?.message ??
                          "Invalid input"
                        }
                      /> */}
                    </div>
                  </div>
                )}
              </div>
            )}

            {methods.watch("of_dw_card_holders").includes("via-email") && (
              <div i2c-grid="12">
                <I2cRadioGroup
                  label="If opting for “E-mail”, please confirm who will manage:"
                  onI2cChange={(e) => {
                    methods.setValue(
                      "of_dw_email_authentication",
                      e.target.value,
                    );
                    if (e.target.value !== "other") {
                      methods.setValue("of_dw_email_authentication_other", "");
                    }
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  <div i2c-grid="grid gap-sm">
                    {emailAgent.map((radio, index) => (
                      <I2cListItem
                        key={index}
                        i2c-grid="4@md"
                        variant="receipt"
                        label={radio.label}
                        sublabel=" "
                        value=" "
                        type="checkbox"
                        checked={
                          methods.watch("of_dw_email_authentication") ===
                            radio.value ?? false
                        }
                      >
                        <I2cRadio
                          slot="prefix"
                          filled
                          checked={
                            methods.watch("of_dw_email_authentication") ===
                              radio.value ?? false
                          }
                          name="ofdw_emailAgent"
                          value={radio.value}
                        ></I2cRadio>
                      </I2cListItem>
                    ))}
                  </div>
                </I2cRadioGroup>
                {methods.watch("of_dw_email_authentication") === "other" && (
                  <div i2c-grid="grid gap-sm" className="mt-16">
                    <div i2c-grid="4@md">
                      <div className="single-field-wrapper">
                        <Controller
                          name="of_dw_email_authentication_other"
                          control={control}
                          render={({ field }) => (
                            <I2cInput
                              {...field}
                              name={"of_dw_email_authentication_other"}
                              className="single-input-field"
                              placeholder="Please Specify"
                              onI2cInput={(e) => {
                                const value = e.target.value;
                                field.onChange(value);
                                methods.trigger();
                                handleValueChanges();
                              }}
                              size="large"
                              label="Enter Details"
                            />
                          )}
                        />
                        {/* <ErrorMessage
                          show={
                            errors.of_dw_email_authentication_other &&
                            methods.formState.touchedFields
                              .of_dw_email_authentication_other
                              ? true
                              : false
                          }
                          message={
                            errors.of_dw_email_authentication_other?.message ??
                            "Invalid input"
                          }
                        /> */}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="section-space">
          <div i2c-grid="grid gap-md">
            <div i2c-grid="12">
              <div className="sub-heading">OTP Delivery</div>
              <I2cCheckboxGroup
                label="Please confirm how would you like the OTP to be delivered to
              cardholders"
              >
                <div i2c-grid="grid gap-sm">
                  {otpDeliveryMethods.map((otpDeliveryMethod, index) => (
                    <I2cListItem
                      key={index}
                      i2c-grid="4@md"
                      variant="receipt"
                      label={otpDeliveryMethod.label}
                      sublabel=""
                      value=""
                      checked={
                        methods
                          .watch("of_dw_otp_delivery")
                          ?.includes(otpDeliveryMethod.value) ?? false
                      }
                      onI2cCheckboxClicked={(e) =>
                        handleOTPDeliveryMethodsChange(otpDeliveryMethod.value)
                      }
                      type="checkbox"
                    >
                      <I2cCheckbox
                        slot="prefix"
                        name="ofdw_otpDelivery"
                        value={otpDeliveryMethod.value}
                        checked={
                          methods
                            .watch("of_dw_otp_delivery")
                            ?.includes(otpDeliveryMethod.value) ?? false
                        }
                        label=""
                        filled
                        className="customCheckbox"
                      ></I2cCheckbox>
                    </I2cListItem>
                  ))}
                </div>
              </I2cCheckboxGroup>
            </div>
          </div>
        </div>
        <div i2c-grid="grid gap-md">
          <div i2c-grid="12">
            <div className="sub-heading">
              Digital Wallet Provisioning Process
            </div>
            <I2cRadioGroup
              label="Would you like to enable In-App Provisioning (Push Provisioning)
              with Digital Wallets?"
              onI2cChange={(e) => {
                methods.setValue("of_dw_provisioning_process", e.target.value);
                methods.trigger();
                handleValueChanges();
              }}
            >
              {inAppProvision.map((radio, index) => (
                <I2cRadioButton
                  key={index}
                  checked={
                    methods.watch("of_dw_provisioning_process") ===
                    radio.toLowerCase()
                  }
                  value={radio.toLowerCase()}
                >
                  {radio}
                </I2cRadioButton>
              ))}
            </I2cRadioGroup>
          </div>
          <div i2c-grid="12">
            <I2cRadioGroup
              label="Will the mobile app be hosted by i2c Inc.?"
              onI2cChange={(e) => {
                if (e.target.value !== "no") {
                  methods.setValue("of_dw_service_enable_via", "");
                }
                methods.setValue("of_dw_i2c_mobile_app_host", e.target.value);
                methods.trigger();
                handleValueChanges();
              }}
            >
              {inAppProvision.map((radio, index) => (
                <I2cRadioButton
                  key={index}
                  checked={
                    methods.watch("of_dw_i2c_mobile_app_host") ===
                    radio.toLowerCase()
                  }
                  value={radio.toLowerCase()}
                >
                  {radio}
                </I2cRadioButton>
              ))}
            </I2cRadioGroup>
          </div>
          {methods.watch("of_dw_i2c_mobile_app_host") === "no" && (
            <div i2c-grid="12">
              <I2cRadioGroup
                label="If you are not taking i2c Inc. hosted mobile app, would you like to enable this service via "
                onI2cChange={(e) => {
                  methods.setValue("of_dw_service_enable_via", e.target.value);
                  methods.trigger();
                  handleValueChanges();
                }}
              >
                <div i2c-grid="grid gap-sm">
                  {enableServiceViaOptions.map((radio, index) => (
                    <I2cListItem
                      key={index}
                      i2c-grid="6@md 4@lg"
                      variant="receipt"
                      label={radio}
                      sublabel=""
                      value=""
                      type="checkbox"
                      checked={
                        methods.watch("of_dw_service_enable_via") ===
                        radio.toLowerCase()
                      }
                    >
                      <I2cRadio
                        checked={
                          methods.watch("of_dw_service_enable_via") ===
                          radio.toLowerCase()
                        }
                        slot="prefix"
                        filled
                        name="ofdw_enableServices"
                        value={radio.toLowerCase()}
                      ></I2cRadio>
                    </I2cListItem>
                  ))}
                </div>
              </I2cRadioGroup>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default DigitalWallet;
